<template>
  <a-cascader
    v-model="defaultValue"
    :fieldNames="{ label: 'name', value: 'name', children: 'childs' }"
    :options="options"
    @change="onChange"
    placeholder="请选择所在区域"
  />
</template>
<script>
import areaData from "./area.json";
export default {
  name: "GlArea",
  props: {
    value: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      options: areaData,
      defaultValue: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val) {
        this.defaultValue = val;
      }
    }
  },
  methods: {
    // 选择完成后的回调
    onChange(value) {
      this.$emit("change", value);
    }
  }
};
</script>
